export const NEWSLETTER_UNSUBSCRIBE_TOKEN_NAME = "unsubscribetoken";
